var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"startseite"},[_c('div',{staticClass:"topcontent"},[_c('StartseiteBanner')],1),_c('div',{staticClass:"centralcontent"},[_c('Startseite1')],1),_c('Startseite2'),_c('div',{staticClass:"centralcontent type2"},[_c('Startseite3'),_c('Startseite4')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }